import { FC } from 'react';
import { Node, mergeAttributes, ReactNodeViewRenderer, NodeViewProps } from '@tiptap/react';
import { Node as ProseMirrorNode } from '@tiptap/pm/model';

export interface StandardLinkExtensionRenderOptions {
  viewComponent?: FC<NodeViewProps>;
  renderText?: (node: ProseMirrorNode) => string;
}

export const createStandardLinkExtension = (renderOptions: StandardLinkExtensionRenderOptions) => {
  const addNodeView = renderOptions.viewComponent ? () => ReactNodeViewRenderer(renderOptions.viewComponent as FC<NodeViewProps>) : null;
  const node = Node.create({
    name: 'standardLink',
    group: 'inline',
    inline: true,
    selectable: false,
    atom: true,
    renderText({ node }) {
      if (renderOptions.renderText) {
        return renderOptions.renderText(node);
      }
      return node.attrs.standardName;
    },
    addAttributes() {
      return {
        standardId: {
          default: null,
        },
        standardName: {
          default: null,
        },
      };
    },
    parseHTML() {
      return [
        {
          tag: 'react-component[data-type="standardLink"]',
        },
      ];
    },
    renderHTML({ HTMLAttributes }) {
      return ['react-component', mergeAttributes(HTMLAttributes, { 'data-type': 'standardLink' })];
    },
    addNodeView,
  });

  return node;
};
